export default __webpack_public_path__ + "static/media/hpRed.0a4dc171.PNG";